<script setup lang="ts">
import { computed } from 'vue';
import { number } from 'vue-types';

import PortalContactLink from './PortalContactLink.vue';

import { type PortalContactQueryVariables, usePortalContactQuery } from '@/graphql/generated/graphql';

const props = defineProps({
  id: number(),
});

const variables = computed<PortalContactQueryVariables>(() => {
  if (props.id) {
    return { id: props.id };
  }
  return undefined as unknown as PortalContactQueryVariables;
});

const { data, fetching } = usePortalContactQuery({ variables, pause: computed(() => !variables.value) });
</script>
<template>
  <div v-if="fetching">
    ...Loading
  </div>
  <PortalContactLink v-else-if="data?.portalContact" :contact="data.portalContact" />
</template>
